import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export const useDraft = (id: string | undefined) => {
  return useQuery({
    queryKey: ["draft", id],
    queryFn: () => api.drafts.get(id!),
    enabled: !!id,
  });
};
